// Test IDs for the auth feature (login, register, password reset, logout).
// Add new keys here as you wire up additional auth UI; see ./index.js for
// the recipe to add a new feature file.
//
// Directive:
//   - Keys are camelCase, values are kebab-case shaped as `<feature>-<element>`
//     (or `<feature>-<element>-<qualifier>` when an element repeats). Examples:
//     'login-submit-button', 'cart-quantity-input', 'product-card-image'.
//   - Reference them in JSX as `data-testid={LOGIN.submitButton}`.

export const LOGIN = {
    emailInput: 'login-email-input',
    passwordInput: 'login-password-input',
    submitButton: 'login-submit-button',
    googleButton: 'login-google-button',
    forgotPasswordLink: 'login-forgot-password-link',
    registerLink: 'login-register-link',
    errorMessage: 'login-error',
};

export const REGISTER = {
    nameInput: 'register-name-input',
    emailInput: 'register-email-input',
    passwordInput: 'register-password-input',
    passwordConfirmInput: 'register-password-confirm-input',
    submitButton: 'register-submit-button',
    loginLink: 'register-login-link',
    errorMessage: 'register-error',
};

export const LOGOUT = {
    button: 'logout-button',
};

export const ACCOUNT = {
    root: 'account-root',
    nameInput: 'account-name-input',
    weightInput: 'account-weight-input',
    heightInput: 'account-height-input',
    unitsSelect: 'account-units-select',
    experienceSelect: 'account-experience-select',
    goalSelect: 'account-goal-select',
    saveButton: 'account-save-button',
    errorMessage: 'account-error',
};
